import appCheck from "@react-native-firebase/app-check"
import { logger } from "capsule"
import React, { useEffect, useState } from "react"
import { AppRegistry, Platform } from "react-native"

import App from "./App"
import { isE2EEnvironment } from "./features/config/environment"
import firebaseInit from "./firebaseInit"

logger(firebaseInit)

const appCheckReadyPromise: Promise<void> = (async () => {
  if (isE2EEnvironment()) {
    logger("🔒 Skipping Firebase App Check initialization in E2E environment")
    return
  }

  try {
    logger("🔒 Initializing Firebase App Check...")

    const rnfbProvider = appCheck().newReactNativeFirebaseAppCheckProvider()
    rnfbProvider.configure({
      android: {
        provider: __DEV__ ? "debug" : "playIntegrity",
      },
      apple: {
        provider: __DEV__ ? "debug" : "appAttest",
      },
      web: {
        provider: "reCaptchaV3",
        siteKey: "unknown",
      },
    })

    await appCheck().initializeAppCheck({
      provider: rnfbProvider,
      isTokenAutoRefreshEnabled: true,
    })

    logger("✅ Firebase App Check initialized successfully")

    // In development mode, get and log the debug token
    if (__DEV__) {
      try {
        const { token } = await appCheck().getToken(true) // Force refresh to get token immediately
        logger("========================================")
        logger("🔑 APP CHECK DEBUG TOKEN:")
        logger(token)
        logger("========================================")
        logger("📋 Copy this token and register it in:")
        logger("Firebase Console > App Check > Apps > Manage debug tokens")
        logger("========================================")
      } catch (tokenError) {
        logger("⚠️ Could not retrieve debug token:", tokenError)
      }
    }
  } catch (error) {
    logger("❌ Failed to initialize App Check:", error)
    // App Check will work in "limited mode"
  }
})()

// Wrapper component to ensure App Check is initialized before rendering the app
const AppWithAppCheck = () => {
  const [appCheckReady, setAppCheckReady] = useState(false)

  useEffect(() => {
    appCheckReadyPromise.then(() => setAppCheckReady(true))
  }, [])

  // Show nothing while initializing (very brief, <100ms typically)
  if (!appCheckReady) {
    return null
  }

  return <App />
}

// Register the wrapped component
AppRegistry.registerComponent("app", () => AppWithAppCheck)

if (Platform.OS === "web") {
  AppRegistry.runApplication("app", {
    // @ts-ignore
    rootTag: document.getElementById("root"),
  })
}
